import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { delay, map, Observable, of } from 'rxjs';
import * as moment from 'moment';
import * as CryptoJS from 'crypto-js';
import { SessionStorageService } from '../services/session-storage.service';


@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  //private httpClient: HttpClient;
  //azureClientID = JSON.parse(localStorage.getItem("BillingPortalProps") ?? "{}").AzureClientID;
  azureClientID = environment.billingProps.aud;
  token: any;
  constructor(private httpClient: HttpClient, private sessStorage: SessionStorageService){
    //httpBackend: HttpBackend) {
    //this.httpClient = new HttpClient(httpBackend);
  }

  checkTokenValidity() {
    const token = this.sessStorage.getItem<string>("apigeeToken-bp");
    //const token = localStorage.getItem("apigeeToken-bp");
    // let res = { token: "iAeAGLgYOJPTU418t8SBw4MLI5d3" }
    if (token) {
      const ciphertext = CryptoJS.enc.Utf8.stringify(
        CryptoJS.enc.Base64.parse(token)
      );
      const apigeePayload = CryptoJS.AES.decrypt(
        ciphertext,
        this.azureClientID!
      ).toString(CryptoJS.enc.Utf8);
      const parsedToken = JSON.parse(apigeePayload);
      if (
        parsedToken?.expiryTime &&
        parsedToken?.expiryTime < moment.utc().toISOString()
      ) {
        this.sessStorage.removeItem("apigeeToken-bp");
        //localStorage.removeItem("apigeeToken-bp");
        return this.fetchToken().pipe(map((res: any) => {
          if (res) {
            const time = moment.utc().add(40, "m").toISOString();

            const ciphertext = CryptoJS.AES.encrypt(
              JSON.stringify({
                token: res.token,
                expiryTime: time,
              }),
              this.azureClientID!
            ).toString();
            const encryptedToken = CryptoJS.enc.Base64.stringify(
              CryptoJS.enc.Utf8.parse(ciphertext)
            );
            this.sessStorage.setItem("apigeeToken-bp", encryptedToken);
            //localStorage.setItem("apigeeToken-bp", encryptedToken);
          }
        }))
      } else return of()
    } else {
      console.log("Not found");
      return this.fetchToken().pipe(map((res: any) => {
        console.log("res" + res)
      // return of(res)
      // .pipe(map((res: any) => {
          if (res) {
            const time = moment.utc().add(40, "m").toISOString();
            const ciphertext = CryptoJS.AES.encrypt(
              JSON.stringify({
                token: res.token,
                expiryTime: time,
              }),
              this.azureClientID!
            ).toString();
            const encryptedToken = CryptoJS.enc.Base64.stringify(
              CryptoJS.enc.Utf8.parse(ciphertext)
            );
            this.sessStorage.setItem("apigeeToken-bp", encryptedToken);
            //localStorage.setItem("apigeeToken-bp", encryptedToken);
          }
        })
      )
      // .pipe(delay(3000))
    }
  }

  fetchToken() {
    return this.httpClient.get(environment.serverFURL + environment.apigeeURI + "token");
  }

  fetchApigeeToken() {
    return this.checkTokenValidity();
  }
}
